<template>
  <div class="mobile-menu">
    <div v-if="activeSubSection" class="back-container" @click="setActiveSubSection()">
      <Icon icon-key="chevron-left" hover-type="OPACITY" />
      <div class="back-label">
        {{ backLabel }}
      </div>
    </div>
    <Icon icon-key="close" hover-type="OPACITY" class="close-container" :on-click="closeMenu" />

    <div class="menu-content">
      <div class="scroll-area mt-20">
        <template v-if="!activeSubSection">
          <!-- NO USER AUTH -->
          <template v-if="!user">
            <bulletin-button to="/wholesale-retail/buyer" full-width variant="primary" @click.native="closeMenu()">
              Join Us
            </bulletin-button>
            <bulletin-button to="/sign-in" class="mt-20" variant="secondary" full-width @click.native="closeMenu()">
              Log in
            </bulletin-button>
          </template>
          <!-- RETAILER REORDER -->
          <bulletin-button
            v-if="user?.role === 'RETAILER'"
            variant="primary"
            to="/reorder"
            full-width
            @click.native="closeMenu()"
          >
            Reorder
          </bulletin-button>
          <!-- RETAILER FAVORITES -->
          <div v-if="user?.role === 'RETAILER'" class="menu-section small-margin-top">
            <div class="menu-section-list">
              <div class="menu-section-list-item flex justify-between align-center pointer">
                <router-link
                  :to="'/favorites'"
                  data-test-id="all-favorites-link"
                  class="flex align-center"
                  @click.native="closeMenu()"
                >
                  <favorite-icon class="mr-5" />
                  <span>Favorites</span>
                </router-link>
              </div>
            </div>
          </div>
          <!-- PROFILE -->
          <div v-if="user" class="menu-section mt-0 pb-15 bb-grey-3">
            <div class="menu-section-list">
              <div
                class="menu-section-list-item flex justify-between align-center pointer"
                @click="setActiveSubSection('DASHBOARD')"
              >
                <div class="flex align-center">
                  <Icon icon-key="profile" class="mr-5" />
                  <span>Dashboard</span>
                </div>
                <Icon icon-key="chevron-right" hover-type="OPACITY" />
              </div>
            </div>
          </div>
        </template>

        <!-- BRAND -->
        <brand-mobile-menu v-if="!activeSubSection && user?.role === 'BRAND'" :on-close="closeMenu" />

        <!-- RETAILER, ADMIN, NONAUTH -->
        <retailer-mobile-menu v-else-if="!activeSubSection" :on-close="closeMenu" />

        <!-- CREDIT AVAILABLE -->
        <credit-available class="mt-20" />

        <!-- DASHBOARD-->
        <dashboard-mobile-menu v-if="activeSubSection === 'DASHBOARD'" />

        <!-- LOGOUT -->
        <bulletin-button v-if="user && user.role" full-width class="mt-20" @click="handleLogout()">
          Log out
        </bulletin-button>
      </div>
    </div>
  </div>
</template>

<script>
import { bodyScrollHelper } from '@/components/mixin/bodyScrollHelper'
import { mapGetters } from 'vuex'
import { sessionHelper } from '../../mixin/sessionHelper'
import DashboardMobileMenu from '@/components/navigation/TheMainMobileMenu/DashboardMobileMenu'
import BrandMobileMenu from './BrandMobileMenu.vue'
import RetailerMobileMenu from './RetailerMobileMenu.vue'
import FavoriteIcon from '../FavoriteIcon.vue'

export default {
  components: {
    DashboardMobileMenu,
    BrandMobileMenu,
    RetailerMobileMenu,
    FavoriteIcon
  },
  mixins: [bodyScrollHelper, sessionHelper],
  data() {
    return {
      show: false,
      activeSubSection: null
    }
  },

  computed: {
    ...mapGetters({
      user: 'userState'
    }),
    backLabel() {
      if (!this.activeSubSection) {
        return
      }
      return null
    }
  },
  mounted() {
    this.show = true

    if (this.isOnADashboardPage) {
      this.activeSubSection = 'DASHBOARD'
    }
  },
  methods: {
    setActiveSubSection,
    closeMenu,
    handleLogout
  }
}

function setActiveSubSection(sectionKey) {
  this.activeSubSection = sectionKey
}

function closeMenu() {
  this.$store.dispatch('navigation/hideSideBar')
}

function handleLogout() {
  this.logout()
  this.closeMenu()
}
</script>

<style lang="scss" scoped src="./TheMainMobileMenu.scss" />
